import axios from "axios";

const API_URL =
  import.meta.env.VITE_CRM_API_URL || "https://dashboard.lono.co.in/api/loans";

const api = axios.create({
  baseURL: API_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

// Add a request interceptor to include the token
api.interceptors.request.use(
  (config) => {
    // Retrieve the token using the key defined in AuthContext.jsx
    const token = localStorage.getItem('token'); 
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export const loanAPI = {
  // Fetch loans assigned to a specific staff member
  getLoansByStaffId: async (staffId) => {
    try {
      const response = await api.get(`/assigned/${staffId}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  getAllStaffWithLoans: async ({ page, limit, role, search } = {}) => {
    try {
      const params = { ...(page && { page }), ...(limit && { limit }), ...(role && { role }), ...(search && { search }) };
      const response = await api.get("/assigned", { params }); // Endpoint in loan.controller.js for getAllStaffWithLoans
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Fetch all unassigned loans
  fetchUnassignedLoans: async () => {
    try {
      // Assumes an interceptor is adding the auth token if needed
      const response = await api.get("/unassigned");
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },
};